<template>
  <a-card :bordered='false' :bodyStyle='{paddingTop:"0px"}'>
    <a-tabs>
      <a-tab-pane :key="1" tab="门店导购">
        <Shopguide></Shopguide>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="经销商导购">
        <Dealerguide></Dealerguide>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import Shopguide from "./Shopguide.vue";
import Dealerguide from "./Dealerguide.vue";

export default {
  components: { 
    Shopguide, 
    Dealerguide
    },
  setup() {},
};
</script>